import React from 'react';

import styles from './styles.cssm';

const ColumnsTemplate = ({
  className = '',
  isNutritionPage = false,
  leftColumn = null,
  leftColumnClassName = '',
  rightColumn = null,
  rightColumnClassName = '',
}) => {
  return (
    <div className={`lg-flex ${className}`}>
      <div
        className={`flex-grow ${styles.column} ${
          isNutritionPage
            ? `order-2 ${styles.columnRight}`
            : `${styles.columnLeft}`
        } ${leftColumnClassName}`}
      >
        {leftColumn}
      </div>
      <div
        className={`flex-grow ${styles.column} ${
          isNutritionPage
            ? `order-1 ${styles.columnLeft}`
            : `${styles.columnRight}`
        } ${rightColumnClassName}`}
      >
        {rightColumn}
      </div>
    </div>
  );
};

export default ColumnsTemplate;
